

export class CompanyRuleDetailsOutputWithStatus implements ICompanyRuleDetailsOutputWithStatus {
    /** The auto-generated id of the company rule details master */
    company_rule_detail_id!: number;
    /** The company name with 255 character */
    company_name!: string;
    /** The date of rule valid from */
    valid_from!: string;
    /** The event date formate should be "MM-dd-yyyy" or  "dd-MM-yyyy" */
    event_date_formate!: string;
    /** The event time formate should be "HH:mm:ss" or  "hh:mm:ss a" */
    event_time_formate!: string;
    /** The device accuracy tolerance in meter */
    device_accuracy_tolerance!: number;
    /** The POI tolerance */
    poi_tolerance!: number;
    /** The speed consideration moment */
    speed_tolerance!: number;
    /** The tour start buffer time should be in HH:mm:ss */
    tourStartBufferTime!: string;
    /** The inactive time */
    inactive_time!: number;
    /** The stoppage time */
    stoppage_time!: number;
    /** The idle time */
    idle_time!: number;
    /** The speed limit */
    speed_limit!: number;
    /** The ignition on first start should be 0 or 1 */
    ignition_on_first_start!: number;
    /** The show cluster should be 0 or 1 */
    show_cluster!: number;
    /** Manage status of company rule details. 0 For De-active, 1 For Active */
    status!: number;

    constructor(data?: ICompanyRuleDetailsOutputWithStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.company_rule_detail_id = _data["company_rule_detail_id"];
            this.company_name = _data["company_name"];
            this.valid_from = _data["valid_from"];
            this.event_date_formate = _data["event_date_formate"];
            this.event_time_formate = _data["event_time_formate"];
            this.device_accuracy_tolerance = _data["device_accuracy_tolerance"];
            this.poi_tolerance = _data["poi_tolerance"];
            this.speed_tolerance = _data["speed_tolerance"];
            this.tourStartBufferTime = _data["tourStartBufferTime"];
            this.inactive_time = _data["inactive_time"];
            this.stoppage_time = _data["stoppage_time"];
            this.idle_time = _data["idle_time"];
            this.speed_limit = _data["speed_limit"];
            this.ignition_on_first_start = _data["ignition_on_first_start"];
            this.show_cluster = _data["show_cluster"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): CompanyRuleDetailsOutputWithStatus {
        data = typeof data === 'object' ? data : {};
        let result = new CompanyRuleDetailsOutputWithStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["company_rule_detail_id"] = this.company_rule_detail_id;
        data["company_name"] = this.company_name;
        data["valid_from"] = this.valid_from;
        data["event_date_formate"] = this.event_date_formate;
        data["event_time_formate"] = this.event_time_formate;
        data["device_accuracy_tolerance"] = this.device_accuracy_tolerance;
        data["poi_tolerance"] = this.poi_tolerance;
        data["speed_tolerance"] = this.speed_tolerance;
        data["tourStartBufferTime"] = this.tourStartBufferTime;
        data["inactive_time"] = this.inactive_time;
        data["stoppage_time"] = this.stoppage_time;
        data["idle_time"] = this.idle_time;
        data["speed_limit"] = this.speed_limit;
        data["ignition_on_first_start"] = this.ignition_on_first_start;
        data["show_cluster"] = this.show_cluster;
        data["status"] = this.status;
        return data; 
    }
}

export interface ICompanyRuleDetailsOutputWithStatus {
    /** The auto-generated id of the company rule details master */
    company_rule_detail_id: number;
    /** The company name with 255 character */
    company_name: string;
    /** The date of rule valid from */
    valid_from: string;
    /** The event date formate should be "MM-dd-yyyy" or  "dd-MM-yyyy" */
    event_date_formate: string;
    /** The event time formate should be "HH:mm:ss" or  "hh:mm:ss a" */
    event_time_formate: string;
    /** The device accuracy tolerance in meter */
    device_accuracy_tolerance: number;
    /** The POI tolerance */
    poi_tolerance: number;
    /** The speed consideration moment */
    speed_tolerance: number;
    /** The tour start buffer time should be in HH:mm:ss */
    tourStartBufferTime: string;
    /** The inactive time */
    inactive_time: number;
    /** The stoppage time */
    stoppage_time: number;
    /** The idle time */
    idle_time: number;
    /** The speed limit */
    speed_limit: number;
    /** The ignition on first start should be 0 or 1 */
    ignition_on_first_start: number;
    /** The show cluster should be 0 or 1 */
    show_cluster: number;
    /** Manage status of company rule details. 0 For De-active, 1 For Active */
    status: number;
}

